var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"search-filter-container"},[(_vm.isActiveSearchTab('search.standards'))?_c('SearchResultFacetsStandards'):_vm._e(),(_vm.isActiveSearchTab('search.assets'))?_c('SearchResultFacetsCollections'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }